<div *ngIf="visible && !disabled" class="tooltip" [attr.data-position]="position" [attr.data-variant]="variant"
  [attr.data-size]="size" role="tooltip" [attr.aria-label]="text">

  <!-- Tooltip content -->
  <div class="tooltip-content">{{ text }}</div>

  <!-- CSS Arrow (no images needed) -->
  <div class="tooltip-arrow" aria-hidden="true"></div>
</div>